import React, { useContext, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";
import * as Yup from "yup";

import "react-bootstrap-typeahead/css/Typeahead.css";
import { APIContext } from "../../../contexts/APIContext";

export default function GenerateDevice({ primaryColor }) {
  const { postGenerateImplant, countriesArray } = useContext(APIContext);
  const [apiResponse, setApiResponse] = useState(null);

  const initialValues = {
    device_type: "E2",
    country_id: 174,
    program_id: 1,
    apply_warranty: true,
    sold_warranty: false,
    is_q_inside: true,
    is_device_tracking: true,
  };

  const validationSchema = Yup.object().shape({
    device_type: Yup.string().required("Required"),
    country_id: Yup.number().required("Please select a country"),
    program_id: Yup.number().required("Required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await postGenerateImplant(values);
      setApiResponse(response.message);
    } catch (error) {
      console.error("Error creating device:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-2">
      <div className="card shadow">
        <div className="card-header">
          <h2 className="mb-0">Create Device</h2>
        </div>
        <div className="card-body">
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({ isSubmitting, setFieldValue, values, setFieldTouched }) => (
              <Form>
                <div className="form-group">
                  <label>Device Type</label>
                  <Field
                    name="device_type"
                    type="text"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="device_type"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </div>

                <div className="form-group">
                  <label>Country</label>
                  <Typeahead
                    id="country_id"
                    labelKey="name"
                    options={countriesArray}
                    placeholder="Select a country..."
                    selected={
                      countriesArray.filter(
                        (c) => c.id === values.country_id
                      )
                    }
                    onChange={(selected) => {
                      const countryId = selected.length > 0 ? selected[0].id : "";
                      setFieldValue("country_id", countryId);
                    }}
                    onBlur={() => setFieldTouched("country_id", true)}
                  />
                  <ErrorMessage
                    name="country_id"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </div>

                <div className="form-group">
                  <label>Program ID</label>
                  <Field
                    name="program_id"
                    type="number"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="program_id"
                    component="div"
                    className="invalid-feedback d-block"
                  />
                </div>

                <div className="form-row d-flex flex-wrap align-items-center mb-3 mt-3">
                  <div className="form-check mr-3">
                    <Field
                      name="apply_warranty"
                      type="checkbox"
                      className="form-check-input"
                      id="applyWarranty"
                      style={{ accentColor: primaryColor }}
                    />
                    <label className="form-check-label" htmlFor="applyWarranty">
                      Apply Warranty
                    </label>
                  </div>

                  <div className="form-check mr-3">
                    <Field
                      name="sold_warranty"
                      type="checkbox"
                      className="form-check-input"
                      id="soldWarranty"
                      style={{ accentColor: primaryColor }}
                    />
                    <label className="form-check-label" htmlFor="soldWarranty">
                      Sold Warranty
                    </label>
                  </div>

                  <div className="form-check mr-3">
                    <Field
                      name="is_q_inside"
                      type="checkbox"
                      className="form-check-input"
                      id="qInside"
                      style={{ accentColor: primaryColor }}
                    />
                    <label className="form-check-label" htmlFor="qInside">
                      Q Inside
                    </label>
                  </div>

                  <div className="form-check">
                    <Field
                      name="is_device_tracking"
                      type="checkbox"
                      className="form-check-input"
                      id="deviceTracking"
                      style={{ accentColor: primaryColor }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="deviceTracking"
                    >
                      Device Tracking
                    </label>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn text-white w-100"
                  style={{
                    backgroundColor: primaryColor,
                    borderColor: primaryColor,
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Create Device"}
                </button>
              </Form>
            )}
          </Formik>

          {apiResponse && (
            <div className="alert alert-success mt-4">
              <h5 className="alert-heading">Device Created Successfully</h5>
              <p>
                <strong>Serial:</strong> {apiResponse.serial}
              </p>
              <p>
                <strong>Validation Code:</strong> {apiResponse.validation_code}
              </p>
              <p>
                <strong>Electronic Serial:</strong>{" "}
                {apiResponse.electronic_serial}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
